import React from "react";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import { Form, Modal, Row } from "react-bootstrap";

import {
  addCollaboratorType,
  updateCollaboratorType,
} from "../../../../../actions/configurables/collaboratorTypes";
import InputLength from "../../../../../enums/InputLength";
import CustomLabel from "../../../../sub/CustomLabel";
import InputTextElement from "../../../../sub/InputTextElement";
import MenuButton from "../../../../sub/bootstrap/MenuButton";

class CollaboratorTypesModalAdmin extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      name: this.props.collaboratorType ? this.props.collaboratorType.name : "",
      nameError: null,
      modal: null,
      disabled: true,
    };
  }

  close() {
    this.props.closeModal();
  }

  onComplete() {
    this.setState({ disabled: true });

    let data = {
      name: this.state.name.trim(),
    };

    let callback = () => {
      this.close();
    };

    if (!this.props.collaboratorType)
      return this.props.onAddCollaboratorType(data, callback);

    data._id = this.props.collaboratorType._id;

    return this.props.onUpdateCollaboratorType(data, callback);
  }

  closeModal() {
    this.setState({ modal: null });
  }

  checkCollaboratorType(name) {
    let isValid = true;
    for (let collaboratorType of this.props.collaboratorTypes) {
      if (collaboratorType.name.toLowerCase() === name.toLowerCase().trim())
        isValid = false;
    }
    return isValid;
  }

  onChange(field, value) {
    this.setState({ [field]: value });
  }

  onBlur(field, value) {
    if (field === "name") {
      if (this.checkCollaboratorType(value)) {
        this.setState({ disabled: false, nameError: null });
      } else {
        this.setState({
          disabled: true,
          nameError: this.props.intl.formatMessage({
            id: "Collaborator.Type.Already.Exist",
          }),
        });
      }
    }
  }

  render() {
    return (
      <Modal
        show={true}
        onHide={() => this.close()}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <FormattedMessage
              id={
                this.props.collaboratorType
                  ? "Collaborator.Type.Update"
                  : "Add.Collaborator.Type"
              }
            />
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="row">
            <div className="col-12 col-lg-8">
              <Form.Group as={Row} className="align-items-center">
                <CustomLabel
                  label={this.props.intl.formatMessage({ id: "Name" })}
                  htmlFor="name"
                  displayAsCol
                  required
                />
                <div id="name" className="col-12 col-md-8">
                  <InputTextElement
                    type="text"
                    className="form-control"
                    maxLength={InputLength.NAME}
                    id="collaboratorType"
                    autoComplete="off"
                    value={this.state.name}
                    onChange={(e) => this.onChange("name", e.target.value)}
                    onBlur={(e) => this.onBlur("name", e.target.value)}
                  />
                  <small className="text-danger">{this.state.nameError}</small>
                </div>
              </Form.Group>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <MenuButton variant="secondary" onClick={() => this.close()}>
            <FormattedMessage id="Cancel" />
          </MenuButton>
          <MenuButton
            onClick={() => this.onComplete()}
            disabled={
              this.state.disabled ||
              this.state.nameError ||
              this.state.name === ""
            }
          >
            <FormattedMessage
              id={this.props.collaboratorType ? "Update" : "Add"}
            />
          </MenuButton>
        </Modal.Footer>
        {this.state.modal}
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    //
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onAddCollaboratorType: (data, successCallback) =>
      dispatch(addCollaboratorType(data, successCallback)),
    onUpdateCollaboratorType: (data, successCallback) =>
      dispatch(updateCollaboratorType(data, successCallback)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(CollaboratorTypesModalAdmin));
